import React from 'react';
import { Form, Input, Button, Select, Checkbox } from 'antd';
import Ajv from 'ajv';
import _ from 'lodash'
import Language from './language';
const { Option } = Select;

const ajv = new Ajv({ strict:false,allErrors: true });

const schema = {
  type: 'object',
  properties: {
    hasColor: {
      type: 'boolean',
      label: 'Do you have a favorite color?',
    },
    color: {
      type: 'string',
      label: 'Color',
      form:{dependencies:['hasColor'],valuePropName:"checked"},
      enum: ['Red', 'Green', 'Blue', 'Yellow'],
    },
    name: {
      type: 'string',
      label: 'Name',
    },
  },
  required: ['name'], // Mark 'name' as required in the schema
  if: {
    properties: { hasColor: { const: true } },
  },
  then: {
    required: ['color'],
  },
};

const validate = ajv.compile(schema);

function getInput(field, isRequired) {
  if (field.enum) {
    return (
      <Select>
        {field.enum.map((option) => (
          <Option key={option} value={option}>
            {option}
          </Option>
        ))}
      </Select>
    );
  } else if (field.type === 'boolean') {
    return <Checkbox>{field.label}</Checkbox>;
  }
  return <Input />;
}

function MyForm() {
  const onFinish = (values) => {
    const isValid = validate(values);

    if (isValid) {
      console.log('Form data is valid:', values);
    } else {
      console.error('Validation errors:', validate.errors);
    }
  };

  return (
    <Form onFinish={onFinish}>
      {Object.keys(schema.properties).map((fieldName) =>{ 
      const {label,form={}} = schema.properties[fieldName];
      
      return <Form.Item
          key={fieldName}
          label={label || ''}
          name={fieldName}
          {...form}
          rules={[
            {
              required: schema.required && schema.required.includes(fieldName),
              message: <Language id="required"/>,
            },
            ({ getFieldValue })=>{return {required:getFieldValue("hasColor")}
            }
          ]}
        >
          {getInput(schema.properties[fieldName], schema.required && schema.required.includes(fieldName))}
        </Form.Item>
      }
      )}
      <Form.Item>
        <Button type="primary" htmlType="submit">
          Submit
        </Button>
      </Form.Item>
    </Form>
  );
}

export default MyForm;



export function myvalidate(data, schema,parentData=[],n) {
  
  if (typeof data !== "object" || typeof schema !== "object") {
    return { isValid: false, errors: "Both data and schema must be objects." };
  }
 
  const {properties,required=[]}=schema;   
  
  let isValid=true;
  const errors={};
  const newData={...data};
  
  Object.keys(properties).forEach((key)=>{    
      const property=properties[key];      
      if ((!(key in data)||typeof data[key]==="undefined")&& required.includes(key) && (data?.active!=false??true)) {        
          errors[key]="required";
          isValid=false;                             
          newData["errors"]={...newData["errors"]||{},[key]:errors[key]};          
      } else {
        if(newData["errors"])delete newData["errors"][key]
        if(newData[key] && newData[key]["errors"])delete newData[key]["errors"]
      }
      
      if (!(key in data))return;
      const {type,options:_options,items,shouldUpdate,defaultOptions=[]}=property;          
      const actualType = Array.isArray(data[key]) ? "array" : typeof data[key];
      
      if(actualType==="undefined")return;
      
      if (type &&  ((type==="integer" && _.isInteger(data[key])) || type===actualType || (type==="string" && (actualType==="undefined" || actualType==="number")))) {
        
       if(_options){
         
         const options = _.isFunction(_options)?shouldUpdate?defaultOptions:_options(parentData):_options;      
         console.log("julien",options);
         
         if(!options.map(o=>o.key).includes(data[key]) &&(data?.active==true??true)){           
            errors[key]=`Property "${key}" not in the list of options".`;
            isValid=false;
            newData["errors"]={...newData["errors"]||{},[key]:errors[key]};
         } else {
           if(newData["errors"])delete newData["errors"][key]
         }
        }

        // Check for nested properties
        if (type === "object") {        
            // const {isValid:tmpValid,errors:tmpErrors}=myvalidate(data[key],property,{value:data})    
            const {isValid:tmpValid,errors:tmpErrors,tmpData}=myvalidate(data[key],property,{value:data,parentData})    
            if(!tmpValid){
              isValid=false;
              errors[key]=tmpErrors;
              newData[key]=tmpData;
              
            } 
        } else if (type==="array") {
            const suberrors={};          
            const subdata=[];          
            data[key].forEach((o,i)=>{
              const {isValid:tmpValid,errors:tmpErrors,tmpData}=myvalidate(o,items,{value:data,parentData},i);            
              if(!tmpValid)suberrors[i]=tmpErrors;   
              subdata.push(tmpData);
            })
            if(!_.isEmpty(suberrors)){
              isValid=false;
              errors[key]=suberrors;
              newData[key]=subdata;
              newData["errors"]=suberrors;
              newData[key]["errors"]=suberrors;
            }
            
        }  
        if(isValid && newData["errors"])delete newData["errors"][key]
         if(isValid && newData[key]["errors"])delete newData[key]["errors"]
      
      } 
      else if (type=="select" ||type=="selectExtent"){
        // console.log("HERE",newData,parentData)
      }
      // else if (type=="selectExtent"){
      //   const {value}=parentData;
      //   const {admin}=value;
      //   console.log("HERE",newData,parentData)
      // }
      else{         
        isValid=false
        errors[key] = "Error" 
        newData["errors"]={...newData["errors"]||{},[key]:errors[key]};
      }                         
  });
  return {isValid,errors,tmpData:newData}

  
}

